import { footerColumns } from "@/mocks/kanliao";

export default function Footer() {
  return (
    <footer className="border-t border-background-200/80 bg-background-200/50">
      <div className="container-px grid grid-cols-1 gap-10 py-12 md:grid-cols-12 md:py-16">
        <div className="md:col-span-5">
          <a href="#home" className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-flashlight-fill text-lg" aria-hidden="true"></i>
            </span>
            <span className="font-heading text-xl font-bold text-foreground-950">看料</span>
          </a>
          <p className="mt-4 max-w-sm text-sm leading-7 text-foreground-600">
            一款内容更新订阅与推送提醒服务。订阅你关心的内容与话题，
            第一时间收到新料推送，不错过任何一次更新，让你永远快人一步。
          </p>
          <a
            href="mailto:hello@kanliao.example"
            className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-primary-700 hover:text-primary-600"
          >
            <i className="ri-mail-send-line" aria-hidden="true"></i>
            hello@kanliao.example
          </a>
        </div>

        {footerColumns.map((col) => (
          <div key={col.title} className="md:col-span-3">
            <h4 className="font-label text-sm font-semibold text-foreground-950">{col.title}</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {col.links.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="inline-flex items-center gap-1.5 text-sm text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    <i className="ri-arrow-right-s-line text-primary-400" aria-hidden="true"></i>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div className="md:col-span-1"></div>
      </div>

      <div className="border-t border-background-300/60">
        <div className="container-px flex flex-col items-center justify-between gap-3 py-5 text-xs text-foreground-500 sm:flex-row">
          <p>© {new Date().getFullYear()} 看料 · 订阅提醒服务。保留所有权利。</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-time-line text-primary-500" aria-hidden="true"></i>
            全天候更新监测，不错过每次更新
          </p>
        </div>
      </div>
    </footer>
  );
}